import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bankPressStyles: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});
export default styles;
